/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-27T10:46:06+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-04T17:15:01+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import getValue from 'lodash/get';
import {connect} from 'react-redux';
import OInputFieldCurrency from 'common/inputs/containers/OInputFieldCurrency';
import MSumCalculatorCheckout from 'common/inputs/components/MSumCalculatorCheckout';
import {
  createNumberFormatter,
} from 'common/inputs/masks/numberMask';
import {i18nInterface} from '../../../utilities/i18n_common';
import {getPaymentConditions} from 'checkout/utils/paymentConditions';




function mapStateToProps(state, ownProps) {
  const model = ownProps.model;
  const deposit = getValue(state, model);

  return {
    deposit,
  };
}


/**
 * OInputFieldCalculatorCheckout - …
**/
class OInputFieldCalculatorCheckout extends Component {
  constructor(props) {
    super(props);
    this.setFormatter(props);
    this.state = {
      ratePerYear: '…',
      paymentConditions: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.includeThousandsSeparator !== this.props.includeThousandsSeparator
            || nextProps.thousandsSeparatorSymbol !== this.props.thousandsSeparatorSymbol
            || nextProps.allowDecimal !== this.props.allowDecimal
            || nextProps.decimalSymbol !== this.props.decimalSymbol
    ) {
      this.setFormatter(nextProps);
    }

    if ( this.props.deposit != nextProps.deposit ) {
      const componentRef = this;
      const processPaymentConditions = (paymentConditions) => {
        componentRef.setState({paymentConditions});
      };

      getPaymentConditions(processPaymentConditions, nextProps.deposit);

    }
  }

  componentDidMount() {
	    const {
	        deposit,
    } = this.props;

    const componentRef = this;
    const processPaymentConditions = (paymentConditions) => {
      componentRef.setState({paymentConditions});
    };

    getPaymentConditions(processPaymentConditions, deposit);

  }

  render() {
    const {
      model,
      modelPaymentConditions,
      defaultValue,
      placeholder,
      disabled,
      validators,
      validateOn,
      asyncValidators,
      messages,
      showErrors,
      includeThousandsSeparator,
      thousandsSeparatorSymbol,
      allowDecimal,
      decimalSymbol,
      unit,
      label,
      description,
      toolLabel,
      toolIcon,
      onPressTool,
      sumName,
      sumInfo,
      deposit,
    } = this.props;

    const {paymentConditions} = this.state;

    return (
      <div className="o-input-field o-input-field-calculator-checkout">
        <OInputFieldCurrency
          model={model}
          defaultValue={defaultValue}
          disabled={disabled}
          placeholder={placeholder}
          validators={validators}
          validateOn={validateOn}
          asyncValidators={asyncValidators}
          messages={messages}
          showErrors={showErrors}
          includeThousandsSeparator={includeThousandsSeparator}
          thousandsSeparatorSymbol={thousandsSeparatorSymbol}
          allowDecimal={allowDecimal}
          decimalSymbol={decimalSymbol}
          unit={unit}
          label={label}
          description={description}
          toolLabel={toolLabel}
          toolIcon={toolIcon}
          onPressTool={onPressTool}
        />
        <MSumCalculatorCheckout
          info={sumInfo}
          modelPaymentConditions={modelPaymentConditions}
          showErrors={showErrors}
          paymentConditions = {deposit ? paymentConditions : ''}
        />
      </div>
    );
  }

  setFormatter(props = this.props) {
    const {
      includeThousandsSeparator,
      thousandsSeparatorSymbol,
      allowDecimal,
      decimalSymbol,
      unit,
    } = props;
    this.formatter = createNumberFormatter({
      prefix: '',
      suffix: (unit) ? ` ${i18nInterface(`units.${unit}`)}` : '',
      includeThousandsSeparator,
      thousandsSeparatorSymbol,
      allowDecimal,
      decimalSymbol,
      decimalLimit: 2,
      allowNegative: false,
      requireDecimal: true, // for the formatter we require the decimals when allowed
    });
  }
}
OInputFieldCalculatorCheckout.propTypes = {
  /**
     * react-redux-form model
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/models.html
     */
  model: PropTypes.string.isRequired,
  /**
     * react-redux-form model
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/models.html
     */
  modelPaymentConditions: PropTypes.string.isRequired,
  /**
     * default value of the component
     */
  defaultValue: PropTypes.number,
  /**
     * placeholder for input
     */
  placeholder: PropTypes.string,
  /**
     * disable the input
     */
  disabled: PropTypes.bool,
  /**
     * hash with validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validators: PropTypes.object,
  /**
     * when validation should be fired
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  validateOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  /**
     * hash with async validator functions
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  asyncValidators: PropTypes.object,
  /**
     * error messages for validatiors
     * see: https://davidkpiano.github.io/react-redux-form/docs/guides/validation.html
     */
  messages: PropTypes.object,
  /**
     * when errors should be shown
     * function which gets passed the props of the form-model
     * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
     */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  /**
     * show thousands seperator
     */
  includeThousandsSeparator: PropTypes.bool.isRequired,
  /**
     * seperator symbol
     */
  thousandsSeparatorSymbol: PropTypes.string.isRequired,
  /**
     * if a decimal value is allowed
     * default: true
     */
  allowDecimal: PropTypes.bool.isRequired,
  /**
     * symbol for decimal seperation
     */
  decimalSymbol: PropTypes.string.isRequired,
  /**
     * display a unit on the right
     */
  unit: PropTypes.string,
  /**
     * label and children are the same
     */
  label: PropTypes.string,
  /**
     * description for the input
     */
  description: PropTypes.any,
  /**
     * label for the tool-button, like 'Help'
     */
  toolLabel: PropTypes.string,
  /**
     * icon for the tool button like 'question-sign'
     */
  toolIcon: PropTypes.string,
  /**
     * displays a tool button with icon and fires
     * whe it is pressed. useful to show extra help infos
     */
  onPressTool: PropTypes.func,
  /**
     * name of the sum field
     */
  sumName: PropTypes.string.isRequired,
  /**
     * info of the sum field
     */
  sumInfo: PropTypes.string,
  /**
     * passed by redux (see mapStateToProps)
     */
  deposit: PropTypes.number,
};
OInputFieldCalculatorCheckout.defaultProps = {
  validateOn: 'blur',
  placeholder: 'Kaution eintippen …',
  includeThousandsSeparator: false,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  unit: 'euro',
  sumName: 'Beitrag pro Jahr:',
  sumInfo: '* Es entstehen KEINE versteckten Gebühren und Kosten.',
};
export default connect(mapStateToProps)(OInputFieldCalculatorCheckout);

